/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Gl_2_TInputs */

const en_mk_tut_gl_2_t = /** @type {(inputs: Mk_Tut_Gl_2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Division`)
};

const id_mk_tut_gl_2_t = /** @type {(inputs: Mk_Tut_Gl_2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisi`)
};

/**
* | output |
* | --- |
* | "Division" |
*
* @param {Mk_Tut_Gl_2_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_gl_2_t = /** @type {((inputs?: Mk_Tut_Gl_2_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Gl_2_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_gl_2_t(inputs)
	return en_mk_tut_gl_2_t(inputs)
});